






































































import CompanySheet from "@/components/company/CompanySheet.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { ITowingDetails, TowingDetails } from "@/models/towing.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop } from "vue-property-decorator";
import TowingForm from "./TowingForm.vue";
import MExpansion from "@/components/utility/mmmint/MExpansion.vue";
import PartnerReportTowingDetailCard from "./PartnerReportTowingDetailCard.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    MTextField,
    MSelect,
    ConfirmActionDialog,
    TowingForm,
    CompanySheet,
    MExpansion,
    PartnerReportTowingDetailCard
  },
  filters: { detailedDate }
})
export default class PartnerReportTowingCard extends PermissionMixin {
  @Prop({ required: true })
  readonly report!: IReport;

  isCreateTowingDialogOpen = false;
  isEditTowingDialogOpen = false;
  showTowings = false;

  towing: ITowingDetails | null = null;
  isTowingLoading = false;
  isTowingValid = false;
  editTowingIndex: number | undefined = undefined;

  get partner() {
    return PartnerModule.partner;
  }

  get reversedTowings() {
    return (this.report.towing || []).slice().reverse();
  }

  startTowing() {
    this.isCreateTowingDialogOpen = true;

    this.towing = new TowingDetails({
      pickupLocation: this.report.location ?? this.report.accidentDetails?.address,
      pickupDate: new Date().toISOString()
    });
  }

  startEditTowing(towingId: string) {
    this.$log.debug(this.report.towing, towingId);

    if (!this.report.towing || !this.report.towing.find(t => t.id === towingId)) {
      return;
    }

    this.towing = new TowingDetails(this.report.towing.find(t => t.id === towingId));
    this.editTowingIndex = this.report.towing.findIndex(t => t.id === towingId);
    this.isEditTowingDialogOpen = true;
  }

  async updateTowing() {
    this.$log.debug(this.towing, this.towing?.id);

    if (!this.towing || this.editTowingIndex === undefined) {
      return;
    }

    this.isTowingLoading = true;

    try {
      const towing = this.report.towing;
      towing?.splice(this.editTowingIndex, 1, this.towing);

      await this.report.updatePartial({
        towingCompanyId: this.towing?.companyId,
        towing: towing?.map(t => t.dto) || []
      });

      this.editTowingIndex = undefined;
      this.isEditTowingDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isTowingLoading = false;
    }
  }

  async addTower() {
    if (!this.towing) {
      return;
    }

    this.isTowingLoading = true;

    try {
      let towing = this.report.towing;
      if (!towing) {
        towing = [this.towing];
      } else {
        towing.push(this.towing);
      }

      await this.report.updatePartial({ towingCompanyId: this.towing?.companyId, towing: towing.map(t => t.dto) });

      this.isCreateTowingDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isTowingLoading = false;
    }
  }
}
